/**
 * Фото борщу по одному запиту на кожне, з памʼяттю про те, які вже доїхали.
 *
 * Обидва флоу (новий борщ і оцінка наявного) раніше ковтали помилку
 * аплоуду в console.error і вважали крок виконаним. 17.10.2026 так зникли
 * три фото підряд: оцінка збереглась, екран сказав «Борщ на мапі!», а про
 * фото не сказав нічого. Тепер результат повертається, і екран фіналу може
 * чесно сказати, скільки не доїхало, та запропонувати повторити саме їх.
 *
 * `uploaded` — індекси, які вже на сервері з попередньої спроби. Повтор
 * пропускає їх, тож друга спроба не дублює фото, що пройшли з першої.
 */
export async function uploadPhotos({ borschId, photos = [], uploaded = [], upload }) {
  // індекси з чужого (старішого) набору фото не мають рахуватись як «доїхали»
  const done = new Set(
    (uploaded || []).filter((i) => Number.isInteger(i) && i >= 0 && i < photos.length)
  );
  for (let i = 0; i < photos.length; i += 1) {
    if (done.has(i)) continue;
    try {
      await upload(borschId, photos[i]);
      done.add(i);
    } catch (e) {
      // одне фото не має тягнути за собою інші, тож лише лог і далі
      console.error('Не вдалося завантажити фото:', e);
    }
  }
  return {
    uploaded: [...done].sort((a, b) => a - b),
    failed: photos.length - done.size,
  };
}
